export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5071.51f0870b.jpg";